// extracted by mini-css-extract-plugin
module.exports = {"container":"tariffs_container__vxkPA","grid":"tariffs_grid__3YVle","tariffsTable":"tariffs_tariffsTable__fvx1O","row":"tariffs_row__2IsJH","cell":"tariffs_cell__1TdqZ"};